import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import transJP from "./trans/JP.json";
import transKR from "./trans/KR.json";
import transTW from "./trans/TW.json";
import transHK from "./trans/HK.json";
import transCN from "./trans/CN.json";
import transEN from "./trans/EN.json";

// the translations
const resources = {
  JP: {
    translation: transJP,
  },
  KR: {
    translation: transKR,
  },
  TW: {
    translation: transTW,
  },
  HK: {
    translation: transHK,
  },
  CN: {
    translation: transCN,
  },
  EN: {
    translation: transEN,
  },
};
let lang = localStorage.getItem("LANG");
i18n.use(initReactI18next).init({
  resources,
  fallbackLng: lang,
  debug: true,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export default i18n;
